// -----------------------------------------------------------------------------
//  constants.ts  ·  Tipos y constantes para el slice Layout
// -----------------------------------------------------------------------------

import {
  LayoutMode,
  LayoutTypes,
  LayoutColor,
  LayoutWidth,
  MenuPositions,
  SideBarTheme,
  SideBarTypes,
  TopbarTheme,
  TwoColumnTheme,
} from "../../constants/layout";

/* ────────────────────────────────────────────────────────────────────────────
   ENUM · acciones del reducer Layout
   ──────────────────────────────────────────────────────────────────────────── */
export enum LayoutActionTypes {
  CHANGE_TWOCOLUMN_THEME   = "@@layout/CHANGE_TWOCOLUMN_THEME",
  CHANGE_LAYOUT_MODE       = "@@layout/CHANGE_LAYOUT_MODE",
  CHANGE_LAYOUT            = "@@layout/CHANGE_LAYOUT",
  CHANGE_LAYOUT_COLOR      = "@@layout/CHANGE_LAYOUT_COLOR",
  CHANGE_LAYOUT_WIDTH      = "@@layout/CHANGE_LAYOUT_WIDTH",
  CHANGE_MENU_POSITIONS    = "@@layout/CHANGE_MENU_POSITIONS",
  CHANGE_SIDEBAR_THEME     = "@@layout/CHANGE_SIDEBAR_THEME",
  CHANGE_SIDEBAR_TYPE      = "@@layout/CHANGE_SIDEBAR_TYPE",
  TOGGLE_SIDEBAR_USER_INFO = "@@layout/TOGGLE_SIDEBAR_USER_INFO",
  TOGGLE_TWO_TONE_ICONS    = "@@layout/TOGGLE_TWO_TONE_ICONS",
  CHANGE_TOPBAR_THEME      = "@@layout/CHANGE_TOPBAR_THEME",

  SHOW_RIGHT_SIDEBAR = "@@layout/SHOW_RIGHT_SIDEBAR",
  HIDE_RIGHT_SIDEBAR = "@@layout/HIDE_RIGHT_SIDEBAR",
}

/* ────────────────────────────────────────────────────────────────────────────
   INTERFAZ · forma completa del estado Layout
   ──────────────────────────────────────────────────────────────────────────── */
export interface LayoutStateTypes {
  /** Tema para layout “two-column” */
  twoColumnTheme:
    | TwoColumnTheme.TWOCOLUMN_LIGHT
    | TwoColumnTheme.TWOCOLUMN_DARK
    | TwoColumnTheme.TWOCOLUMN_BRAND
    | TwoColumnTheme.TWOCOLUMN_GRADIENT;

  /** Modo general del layout (default, detached…) */
  layoutMode:
    | LayoutMode.LAYOUT_DEFAULT
    | LayoutMode.LAYOUT_DETACHED;

  /** Tipo de layout: vertical, horizontal, etc. */
  layoutType:
    | LayoutTypes.LAYOUT_VERTICAL
    | LayoutTypes.LAYOUT_TWO_COLUMN
    | LayoutTypes.LAYOUT_DETACHED
    | LayoutTypes.LAYOUT_HORIZONTAL;

  /** Esquema de colores (claro u oscuro) */
  layoutColor:
    | LayoutColor.LAYOUT_COLOR_LIGHT
    | LayoutColor.LAYOUT_COLOR_DARK;

  /** Ancho del layout (fluid o boxed) */
  layoutWidth:
    | LayoutWidth.LAYOUT_WIDTH_FLUID
    | LayoutWidth.LAYOUT_WIDTH_BOXED;

  /** Posición del menú */
  menuPosition:
    | MenuPositions.MENU_POSITION_FIXED
    | MenuPositions.MENU_POSITION_SCROLLABLE;

  /** Tema del sidebar izquierdo */
  leftSideBarTheme:
    | SideBarTheme.LEFT_SIDEBAR_THEME_LIGHT
    | SideBarTheme.LEFT_SIDEBAR_THEME_DARK
    | SideBarTheme.LEFT_SIDEBAR_THEME_BRAND
    | SideBarTheme.LEFT_SIDEBAR_THEME_GRADIENT;

  /** Tipo de sidebar izquierdo */
  leftSideBarType:
    | SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT
    | SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED
    | SideBarTypes.LEFT_SIDEBAR_TYPE_COMPACT
    | SideBarTypes.LEFT_SIDEBAR_TYPE_FULL
    | SideBarTypes.LEFT_SIDEBAR_TYPE_FULLSCREEN;

  /** Mostrar avatar/usuario encima del menú lateral */
  sidenavUser: boolean;

  /** Iconos two-tone activos */
  showTwoToneIcons: boolean;

  /** Mostrar información de usuario en sidebar */
  showSidebarUserInfo: boolean;

  /** Tema del topbar */
  topbarTheme:
    | TopbarTheme.TOPBAR_THEME_LIGHT
    | TopbarTheme.TOPBAR_THEME_DARK
    | TopbarTheme.TOPBAR_THEME_BRAND;

  /** Estado del sidebar derecho */
  isOpenRightSideBar: boolean;
}

/* ────────────────────────────────────────────────────────────────────────────
   Re-exportación (por compatibilidad con importaciones existentes)
   ──────────────────────────────────────────────────────────────────────────── */

